import { useMemo } from 'react';
import { PROVIDERS } from './providerConfiguration';
import { useConfig } from '../../config';

function useMediaProviders3pNames() {
  const { mediaProviders } = useConfig();

  return useMemo(() => {
    if (!mediaProviders) {
      return [];
    }

    const perProviderCounters = {};

    return mediaProviders
      .filter((provider) => {
        const code = provider?.code?.toLowerCase?.();
        return Boolean(code && PROVIDERS[code]);
      })
      .map((provider, index) => {
        const code = provider.code.toLowerCase();
        const counter = perProviderCounters[code] ?? 0;
        perProviderCounters[code] = counter + 1;

        const instanceId = String(provider.mediaProviderId ?? counter);
        const key = `${code}-${instanceId}`;

        return {
          key,
          code,
          mediaProviderId: provider.mediaProviderId ?? undefined,
          displayName:
            provider.title || PROVIDERS[code]?.displayName || provider.code,
          provider: {
            ...provider,
            providerConfigurationKey: code,
          },
        };
      });
  }, [mediaProviders]);
}

export default useMediaProviders3pNames;
